import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPaymentProviderStart } from '../../../../store/redux-slices/payment'

const useDeposit = (selectedTab) => {
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const { loading, paymentProviders } = useSelector(state => state.payment)

  useEffect(() => {
    if (selectedTab === 'deposit') {
      dispatch(getPaymentProviderStart({
        isTenant: false,
        paymentType: 'deposit',
        aggregator: '',
        tenant: 'true',
        group: '',
        status: '',
        tenantIds: []
      }))
    }
  }, [selectedTab])

  useEffect(() => {
    const myData = {}
    if (!Object.keys(myData)?.length && paymentProviders) {
      paymentProviders.forEach(({ aggregator, group }) => {
        if (myData?.[aggregator]?.[group] === undefined) {
          const provDetails = paymentProviders.filter((item) =>
            item.group === group && item.aggregator === aggregator)
          if (provDetails?.length) {
            if (myData[aggregator] === undefined) myData[aggregator] = []
            if (myData[aggregator][group] === undefined) myData[aggregator][group] = []
            myData[aggregator][group] = provDetails
          }
        }
      }
      )
      setData(myData)
    }
  }, [paymentProviders])

  return {
    data,
    loading
  }
}

export default useDeposit
